export const BASE_SERVICE_PATH = '/base-service';
export const DETECTION_PATH = '/detection';
export const AUTHENTICATION_PATH = '/authentication';
export const ADVANCED_SERVICE_PATH = '/advanced-service';
export const LEARNING_PATH = '/learning';
export const SERVICES_PATH = '/services';
export const ANNOTATION_SERVICE_PATH = '/annotation-service';
export const FREE_BASE_SERVICE_PATH = '/free/base-service';
export const FREE_DETECTION_PATH = '/free/detection';
export const FREE_AUTHENTICATION_PATH = '/free/authentication';
export const FREE_ADVANCED_SERVICE_PATH = '/free/advanced-service';
export const FREE_LEARNING_PATH = '/free/learning';
export const FREE_SERVICES_PATH = '/free/services';
export const FREE_ANNOTATION_SERVICE_PATH = '/free/annotation-service';
export const PASSWORD_REGEX = /(?=.*[a-z])(?=.*[A-Z])/;

export const Service = Object.freeze({
    LINE_SEGMENT_DETECTOR: 1,
    ELSDC: 16,
    // ARCLINE_DETECTOR: 2,
    CONTRAST_ENHANCEMENT: 3,
    DENOISING: 4,
    DEBLURRING: 5,
    DERAINING: 6,
    OBJECT_DETECTION: 7,
    COUNT_OBJECTS: 8,
    RESOLUTION_ENHANCEMENT: 9,
    POSE_ESTIMATION: 10,
    FACE_DETECTION: 11,
    FACE_RECOGNITION: 12,
    INPAINTING: 13,
    CORRECTIVE_EXERCISE: 14,
    ANOMALY: 15,
    CLASSIFICATION_ANNOTATION: 31,
    BOUNDARY_ANNOTATION: 32,
    BOUNDING_BOX_ANNOTATION: 33,
    DEEP_LEARNING: 30
});

export const FileType = Object.freeze({
    INPUT_IMAGE: 1,
    MASK_IMAGE: 2,
    TEST_IMAGE: 3,
    OUTPUT_IMAGE: 100,
    COORDINATES: 101,
    ELLIPSE_INFOS: 102,
    POLYGAN_INFOS: 103,
    OUTPUT_LABELS_IMAGE: 104,
    OUTPUT_DOT_IMAGE: 105,
    OBJECTS: 106,
    ANNOTATION_FILE: 107,
    MODEL: 108,
    TRAINING_DIAGRAMS: 109,
    CLASSES: 110,
    DERAILS: 111,
    LANDMARKS: 112,
    DETAILS: 113,
    WORLD_LANDMARKS: 114,
    PLOT_SKELETON: 115,
    MEDIA_PIPE_LANDMARK: 116,
    WHITE_BG: 117,
    PLOT_3D: 118,
    SUMMARY: 200
});

export const ServiceResultOutputTypes =
    [
        {
            type: FileType.OUTPUT_IMAGE,
            services:
                [
                    Service.LINE_SEGMENT_DETECTOR,
                    Service.ARCLINE_DETECTOR,
                    Service.CONTRAST_ENHANCEMENT,
                    Service.DENOISING,
                    Service.DEBLURRING,
                    Service.DERAINING,
                    Service.OBJECT_DETECTION,
                    Service.COUNT_OBJECTS,
                    Service.RESOLUTION_ENHANCEMENT,
                    Service.POSE_ESTIMATION,
                    Service.FACE_DETECTION,
                    Service.FACE_RECOGNITION,
                    Service.INPAINTING,
                    Service.ANOMALY,
                    Service.CORRECTIVE_EXERCISE,
                    Service.ELSDC,
                    Service.CLASSIFICATION_ANNOTATION,
                    Service.BOUNDARY_ANNOTATION,
                    Service.BOUNDING_BOX_ANNOTATION
                ]
        },
        {
            type: FileType.OUTPUT_DOT_IMAGE,
            services:
                [
                    Service.ARCLINE_DETECTOR
                ]
        },
        {
            type: FileType.LANDMARKS,
            services:
                [
                    Service.FACE_DETECTION
                ]
        },
        {
            type: FileType.OUTPUT_LABELS_IMAGE,
            services:
                [
                    Service.ELSDC
                ]
        },
        {
            type: FileType.WHITE_BG,
            services:
                [
                    Service.CORRECTIVE_EXERCISE
                ]
        },
        {
            type: FileType.PLOT_3D,
            services:
                [
                    Service.CORRECTIVE_EXERCISE
                ]
        }
    ]

export const ParameterType = Object.freeze({
    RANGE_INT: 1,
    RANGE_DOUBLE: 2,
    TEXT_INT: 3,
    TEXT_DOUBLE: 4,
    RADIO_BUTTONS: 5,
    COMBOBOX: 6,
    MULTI_SELECTIZE: 7,
    DATASET: 8,
    DROP_ZONE: 9
});

export const UserType = Object.freeze({
    ADMIN: 'admin',
    SUPPORTER: 'supporter',
    NORMAL: 'normal'
});

export const LanguageType = Object.freeze({
    JAVA: "Java",
    NODE_JS: "NodeJS",
    CSHARP: "C#",
    PYTHON: "Python"
});

export const DNN = Object.freeze({
    DETECTRON: 1,
    YOLOV_5: 2,
    YOLOV_7: 3,
});

export const DlStatus = Object.freeze({
    INITIALIZATION: 1,
    PENDING: 2,
    INITIALIZATION_ERROR: 3,
    ANNOTATING: 4,
    TRAINING: 5,
    TRAINING_ERROR: 6,
    STOP_TRAINING: 7,
    DONE: 8
});

export const Category = Object.freeze({
    BASE_SERVICE: 1,
    DETECTION: 2,
    LEARNING: 4,
    AUTHENTICATION: 5,
    ANNOTATION_SERVICE: 6,
    ADVANCED_SERVICE: 7
});

export const SidebarItems = [
    { key: 'line-segment-detector', labelKey: 'baseSidebar.lineSegmentDetector', serviceType: Service.LINE_SEGMENT_DETECTOR, category: Category.BASE_SERVICE },
    // { key: 'arcLine-detector', labelKey: 'baseSidebar.arcLineDetector', serviceType: Service.ARCLINE_DETECTOR, category: Category.BASE_SERVICE },
    { key: 'arcLine-detector', labelKey: 'baseSidebar.arcLineDetector', serviceType: Service.ELSDC, category: Category.BASE_SERVICE },
    { key: 'contrast-enhancement', labelKey: 'baseSidebar.contrastEnhancement', serviceType: Service.CONTRAST_ENHANCEMENT, category: Category.BASE_SERVICE },
    { key: 'denoising', labelKey: 'baseSidebar.denoising', serviceType: Service.DENOISING, category: Category.BASE_SERVICE },
    { key: 'deblurring', labelKey: 'baseSidebar.deblurring', serviceType: Service.DEBLURRING, category: Category.BASE_SERVICE },
    { key: 'deraining', labelKey: 'baseSidebar.deraining', serviceType: Service.DERAINING, category: Category.BASE_SERVICE },
    { key: 'resolution-enhancement', labelKey: 'baseSidebar.resolutionEnhancement', serviceType: Service.RESOLUTION_ENHANCEMENT, category: Category.BASE_SERVICE },
    { key: 'inpainting', labelKey: 'baseSidebar.inpainting', serviceType: Service.INPAINTING, category: Category.BASE_SERVICE },
    { key: 'object-detection', labelKey: 'baseSidebar.objectDetection', serviceType: Service.OBJECT_DETECTION, category: Category.DETECTION },
    { key: 'pose-estimation', labelKey: 'baseSidebar.poseEstimation', serviceType: Service.POSE_ESTIMATION, category: Category.DETECTION },
    { key: 'face-detection', labelKey: 'baseSidebar.faceDetection', serviceType: Service.FACE_DETECTION, category: Category.DETECTION },
    { key: 'count-objects', labelKey: 'baseSidebar.countObjects', serviceType: Service.COUNT_OBJECTS, category: Category.DETECTION },
    { key: 'anomaly-detection', labelKey: 'baseSidebar.anomalyDetection', serviceType: Service.ANOMALY, category: Category.DETECTION },
    { key: 'face-recognition', labelKey: 'baseSidebar.faceRecognition', serviceType: Service.FACE_RECOGNITION, category: Category.AUTHENTICATION },
    { key: 'corrective-exercise', labelKey: 'baseSidebar.correctiveExercise', serviceType: Service.CORRECTIVE_EXERCISE, category: Category.ADVANCED_SERVICE },
    { key: 'boundary-annotation', labelKey: 'baseSidebar.boundaryAnnotation', serviceType: Service.BOUNDARY_ANNOTATION, category: Category.ANNOTATION_SERVICE },
    { key: 'bounding-box-annotation', labelKey: 'baseSidebar.boundingBoxAnnotation', serviceType: Service.BOUNDING_BOX_ANNOTATION, category: Category.ANNOTATION_SERVICE },
    { key: 'classification-annotation', labelKey: 'baseSidebar.classificationAnnotation', serviceType: Service.CLASSIFICATION_ANNOTATION, category: Category.ANNOTATION_SERVICE },
    { key: 'deep-learning', labelKey: 'baseSidebar.dl', serviceType: Service.DEEP_LEARNING, category: Category.LEARNING }
];

export const ServiceRequestStatus = Object.freeze({
    REGISTERED: 1,
    PENDING: 2,
    IN_COMMUNICATION: 3,
    WAIT_FOR_PAY: 4,
    IS_PAID: 5,
    IN_PROGRESS: 6,
    APPROVED: 7,
    FINALIZED: 8,
    REJECTED: 9
});

export const ContactMethod = Object.freeze({
    TEL: 1,
    EMAIL: 2,
    OTHER: 3
});

export const GatewayType = Object.freeze({
    OTHER: 11,
    PAYPAL:10
});

export const PaymentFor = Object.freeze({
    SERVICE_REQUEST: 1,
    BUY_LICENSE: 2,
    EXTEND_DATE: 3,
    UPGRAGE_RAM: 4,
    DOWNGRADE_RAM: 5,
    UPGRADE_CPU: 6,
    DOWNGRADE_CPU: 7,
    UPGRADE_DISK: 8,
    TEST_API_KEY: 100
});

export const AnnotationType = Object.freeze({
    CLASSIFICATION: 1,
    BOUNDARY: 2,
    BOUNDING_BOX: 3
})

export const ActionType = Object.freeze({
    NOT_SAVED: 1,
    AUTO_SAVE: 2,
    SAVE_ENV: 3,
    DOWNLOAD: 4,
    SAVE_IN_CLOUD: 5
})

export const ExtraOptionType = Object.freeze({
    DROPZONE: 1,
    MASK: 2
})

export const AllowedMimeTypes = ['image/bmp', 'image/jpeg', 'image/png', 'image/webp', 'image/gif', 'image/pjpeg'];